module.exports = __webpack_public_path__ + "img/headphone.e2006768.svg";